import moment from 'moment';

const TIME_FMT = 'HH:mm:ss';
const DATE_FMT = 'YYYY-MM-DD';
const FULL_DT_FMT = DATE_FMT + ' ' + TIME_FMT;

// The shortest run the automation validators will accept.
export const MIN_EVENT_MINUTES = 10;

export function combineDateTime (date, time) {
    return moment(
        date.format(DATE_FMT) + ' ' + time.format(TIME_FMT),
        FULL_DT_FMT
    );
}

/**
 * Keep the Auto Stop pair anchored to the start.
 *
 * `EventMock` seeds stopDate/stopTime at mount time to `now + 10m` and nothing
 * moved them again, so scheduling an event for a future date left the stop
 * behind on today. The automation validators then rejected a form the user had
 * every reason to believe was complete. Preserve whatever duration is already
 * on the form, never dropping below the minimum the validators require.
 *
 * @param {Object} edits current wizard edits
 * @param {String} name the start field being changed -- 'startDate'|'startTime'
 * @param {Object} value the incoming moment for that field
 * @returns {Object|null} `{stopDate, stopTime}` updates, or null when there is
 *   not enough valid state to realign against.
 */
export default function realignStop (edits, name, value) {
    const startDate = name === 'startDate' ? value : edits.startDate;
    const startTime = name === 'startTime' ? value : edits.startTime;

    const required = [
        startDate,
        startTime,
        edits.startDate,
        edits.startTime,
        edits.stopDate,
        edits.stopTime
    ];

    if (required.some(m => !moment.isMoment(m) || !m.isValid())) return null;

    const prevStart = combineDateTime(edits.startDate, edits.startTime);
    const prevStop = combineDateTime(edits.stopDate, edits.stopTime);
    const nextStart = combineDateTime(startDate, startTime);

    let duration = prevStop.diff(prevStart, 'minutes');
    if (!(duration >= MIN_EVENT_MINUTES)) duration = MIN_EVENT_MINUTES;

    // `nextStart` is a fresh moment, so mutating it here is safe.
    const nextStop = nextStart.add(duration, 'minutes');

    // Mirror how EventMock seeds these: both halves carry the same instant.
    return {
        stopDate: nextStop.clone(),
        stopTime: nextStop.clone()
    };
}
